module.exports = __webpack_public_path__ + "static/media/en_badge_web_generic-cut.3591667a.png";